'use client';

import { useLocale } from 'use-intl';
import NextImage from '../ui/next-image';
import NextLink from '../next-link';

const BrandCard = ({ info, isMobile }) => {
  const locale = useLocale();
  return (
    <NextLink
      href={info?.url ? `/${info?.url}` : '#'}
      className={`border-border flex flex-col items-center justify-center gap-3 rounded-xl border bg-white p-2 pb-3 shadow sm:max-h-56`}
    >
      <NextImage
        alt={info?.[`title-${locale}`] || ''}
        className={
          'max-h-[170px] min-h-[170px] w-full rounded-xl object-contain max-sm:max-h-[110px] max-sm:min-h-[110px] max-sm:max-w-[110px] max-sm:min-w-[110px]'
        }
        src={
          isMobile ? info?.[`mobile-img-${locale}`] : info?.[`img-${locale}`]
        }
        width={170}
        height={170}
      />

      <p
        className={`text-center text-sm font-semibold capitalize max-sm:text-[11px]`}
        title={info?.[`title-${locale}`] || ''}
      >
        {info?.[`title-${locale}`] || ''}
      </p>
    </NextLink>
  );
};

export default BrandCard;
